import React, { Fragment, useContext, useEffect, useState } from "react";
import Div from "@jumbo/shared/Div";
import {
  CardContent,
  Card,
  Typography,
  Tooltip,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Box,
  Drawer,
  Pagination,
  Stack,
  Menu,
  MenuItem,
  Fade,
  Button,
  IconButton,
  Select,
  FormControl,
  InputAdornment,
  FormHelperText,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CachedIcon from "@mui/icons-material/Cached";
import FilterListIcon from "@mui/icons-material/FilterList";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers";
import LoadingButton from "@mui/lab/LoadingButton";
import { Formik, useFormik } from "formik";
import debounce from "lodash/debounce";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import { Encrytion } from "app/utils/EncryptionHelpers";
import { Search, SearchIconWrapper, StyledInputBase } from "./style";
import { AuthenticationContext } from "app/utils/constants/AuthContext";
import SkeletonTableLoader from "./SkeletonLoader";
import NoRecordsFound from "./NoRecordsFound";
import { config } from "app/config/main";
import LoaderComp from "app/components/loader/Loader";
import { ToastServices } from "app/services/toastServices";
import * as yup from "yup";
import { logoutAction } from "app/redux/actions/authAction";
import AddIcon from "@mui/icons-material/Add";
import Swal from "sweetalert2";

const ManageJobs = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [filterOpen, setFilterOpen] = React.useState(false);
  const getToken = sessionStorage.getItem("token");
  const decrpttoken = Encrytion(getToken);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [enqData, setenqData] = useState({
    category: "",
    status: "",
    toDate: "",
    fromDate: "",
    search: "",
    limit: "10",
    offset: "1",
    sortByType: "",
    sortByKey: "",
  });
  const [category, Setcategory] = useState(); 
  const [status, setStatus] = useState();
  const [sortType, setSortType] = useState("ASC");
  const [sortKey, setSortKey] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const [filterData, setFilterData] = useState({});
  const [loading, setLoading] = useState(false);
  const [isloading, setisLoading] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPage, setTotalPage] = useState(0);
  const [dateopen, setDateOpen] = useState(false);
  const [todateOpen, setTodateOpen] = useState(false);
  const [statusCode, setStatusCode] = useState(false);
  const { isAuthenticated } = useContext(AuthenticationContext);
  const [error, setError]  = useState(false);

 
  // initial api 

  const loadData = async () => {
    setLoading(true);
    const mergedData = { ...enqData };
    const {
      category,
      status,
      toDate,
      fromDate,
      search,
      limit,
      offset,
      sortByType,
      sortByKey,
    } = mergedData;
    let api = `${config.apiUrl}/jobs/list?`;

  
    if (category) api += `&category=[${category}]`;
    if (status) api += `&status=[${status}]`;
    if (toDate) api += `&toDate=${toDate}`;
    if (fromDate) api += `&fromDate=${fromDate}`;
    if (search) api += `&searchWith=${search}`;
    if (limit) api += `&limit=${limit}`;
    if (offset) api += `&offset=${offset}`;
    if (sortByType) api += `&sortByType=${sortByType}`;
    if (sortByKey) api += `&sortByKey=${sortByKey}`;

    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${decrpttoken}`,
      },
    };

    await fetch(api, options)
      .then((res) => res.json())
      .then((res) => {
        setData(res.data);
        setCount(res?.status ? res.count : 0);
        setTotalPage(res?.status ? res.totalPages : 0);
        setLoading(false);

        if (res?.statusCode == 404) {
          setLoading(false);
          setError(true)
          
        }

        if (res?.statusCode == 401) {
          navigate("/");
          logoutAction();
          setStatusCode(true);
        }
       
        
       
      }).catch(err =>{
        setLoading(false);
         setError(true)
      });
  };

  const loadStatus = async () => {
      const newStatus = [
        {id : 0, statusName:"Inactive"},
        {id : 1, statusName:"Active"},
      ]
      setStatus(newStatus);
  };

  const loadCountry = async () => {
    const options = {
      method: "GET",
      headers: {
        "Content-Type":"application/json" ,
        'Authorization': `Bearer ${decrpttoken}` ,
      },
    };
    await fetch(`${config.apiUrl}/job-category/raw_categories?status=1`, options)
      .then((res) => res.json())
      .then((res) => {
        Setcategory(res.data);
      });
  };

  const handleClick = (event, i) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex(i);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedIndex(null);
  };

  // change status 

  const handleStatus = async (id , status) => {
    setAnchorEl(null);
    setSelectedIndex(null);
    const userData = {
      id : id,
      status:status === 1 ? 0 : 1
    }
    const options = {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${decrpttoken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userData),
    }

    try {
      await fetch(`${config.apiUrl}/jobs/status`, options)
        .then((res) => res.json())
        .then((res) => {
         
          if (res?.status === true) {
            setLoading(false);
            ToastServices.SucessToast(res?.message);
            setenqData({ ...enqData,});
           
          } else if (res?.status === false) {
            ToastServices.ErroToast(res?.message);
            setLoading(false);
          } else if (res?.statusCode === 429) {
            setLoading(false);
            ToastServices.ErroToast("Something went wrong");
          } else if (res?.statusCode === 500) {
            ToastServices.ErroToast("Something went wrong");
            setLoading(false);
          } else if (res?.statusCode === 404) {
            ToastServices.ErroToast("Something went wrong");
            setLoading(false);
          }
        });
    } catch (err) {
      setLoading(false);
      ToastServices.ErroToast("Something went wrong");
      
    }


  
  };

// sorting 

  const handleSort = (column) => {
    const newSorttype =
      sortKey === column && sortType === "ASC" ? "DESC" : "ASC";
    setSortType(newSorttype);
    setSortKey(column);
    setenqData({
      ...enqData,
      sortByType: newSorttype,
      sortByKey: column
    });
  };

  const handlePaginationChange = (event, page) => {
    setPage(page);
    setenqData({ ...enqData, offset: page });
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(event.target.value);
    setPage(1);
    setenqData({ ...enqData, limit: event.target.value,  offset: 1});
  };

  // search 

  const debouncedSearch = debounce((input) => {
   
    const lowerCaseInput = input.toLowerCase();
    setenqData({ ...enqData, search: input });
    
   
  }, 3000);


  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
    let input = event.target.value.toLowerCase();
    debouncedSearch(input);
  };

  const handleClearSearch = () => {
    if (searchInput != "") {
      setSearchInput("");
      // Clear the input value in the DOM
      const inputElement = document.querySelector(".search input");
      if (inputElement) {
        inputElement.value = "";
      }
      setenqData({ ...enqData, search: "" });
    }
  };

  // delete 

  const handleDelete = async (id, ) => {
    setAnchorEl(null);
    setSelectedIndex(null);
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then((result) => {
      if (result.isConfirmed) {
        deleteAction(id)
      }
    });
  }

  const deleteAction = async (id) =>{
    const userData = {
      id:id
    }
    const options = {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${decrpttoken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userData),
    }
    try {
      await fetch(`${config.apiUrl}/jobs/delete/${id}`, options)
        .then((res) => res.json())
        .then((res) => {
         
          if (res?.status === true) {
            setLoading(false);
            Swal.fire({
              title: "Deleted!",
              text: "Your item has been deleted.",
              icon: "success"
            }).then(()=>{
              setenqData({ ...enqData,});
              
            })
          } else if (res?.status === false) {
            ToastServices.ErroToast(res?.message);
            setLoading(false);
          } else if (res?.statusCode === 429) {
            setLoading(false);
            ToastServices.ErroToast("Something went wrong");
          } else if (res?.statusCode === 500) {
            ToastServices.ErroToast("Something went wrong");
            setLoading(false);
          } else if (res?.statusCode === 404) {
            ToastServices.ErroToast("Something went wrong");
            setLoading(false);
          }
        });
    } catch (err) {
      setLoading(false);
      ToastServices.ErroToast("Something went wrong");
     }
  }

  // fillter 

  function handleFilterToggle() {
    setFilterOpen(!filterOpen);
  }
  function handleFilterClose() {
    setFilterOpen(false);
  }
  const handleClear = () => {
    const initialValues = formik.initialValues;
    const currentValues = formik.values;

    // Check if any of the current values differ from the initial values
    const shouldReset = Object.keys(currentValues).some(
      (key) => currentValues[key] !== initialValues[key]
    );

    // Reset formik values only if they differ from initial values
    if (shouldReset) {
      formik.resetForm();
      handleReset();
      setSearchInput("");
      // Clear the input value in the DOM
      const inputElement = document.querySelector(".search input");
      if (inputElement) {
        inputElement.value = "";
      }
    }
    handleFilterClose();
    //  ToastServices.SucessToast("Data reset successfully")
  };
  const handleFilter = () => {
    handleFilterToggle();
    handleClose();
  };

  const validationSchema = yup.object().shape({
    fromDate: yup.date()
    .nullable()
    .transform((value, originalValue) => {
      if (originalValue === '' || originalValue === null) {
        return null; 
      }
      const date = moment(originalValue, moment.ISO_8601, true);
      return date.isValid() ? date.toDate() : new Date(NaN); 
    })
    .typeError('From date must be a valid date')
    .when('toDate', {
      is: (toDate) => toDate && !isNaN(toDate.getTime()),
      then: yup.date().required('From date is required when To date is selected')
    })
    .test(
      "fromDate-before-toDate",
      "From Date cannot be after To Date",
      function (fromDate) {
        const { toDate } = this.parent;
        return (
          !fromDate ||
          !toDate ||
          moment(fromDate).isSameOrBefore(toDate, "day")
        );
      }
    ),
  toDate: yup.date()
    .nullable()
    .test(
      "toDate-after-fromDate",
      "To date cannot be before From date",
      function (toDate) {
        const { fromDate } = this.parent;
        return (
          !toDate ||
          !fromDate ||
          moment(toDate).isSameOrAfter(fromDate, "day")
        );
      }
    ),
  });
  
  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      category: "",
      status: "",
      toDate: null,
      fromDate: null,
    },
  
    onSubmit: async (values) => {
      handleSubmit(values);
      handleFilterClose();
    },
  });
  
  const handleSubmit = (values) => {
    setisLoading(true);
    const userData = {
      category: values.category,
      status: values?.status ? values?.status : "",
      toDate: !values?.toDate ? "" :  moment(values?.toDate).format("YYYY-MM-DD"),
      fromDate: !values?.fromDate ? "" : moment(values?.fromDate).format("YYYY-MM-DD"),
    };
    const hasNonEmptyValues = Object.values(userData).some(value => value !== "");
    setFilterData(userData);
    if (hasNonEmptyValues) {
      setenqData({ ...enqData, ...userData });
      ToastServices.SucessToast("Data filtered successfully");
    }
    setisLoading(false);
  };

  // reset 

  const handleReset = () => {
    formik.resetForm();
    setenqData({
      category: "",
      status: "",
      toDate: "",
      fromDate: "",
      search: "",
      limit: "",
      offset: "",
      sortByType: "",
      sortByKey: "",
    });
    setSearchInput("");
    // Clear the input value in the DOM
    const inputElement = document.querySelector(".search input");
    if (inputElement) {
      inputElement.value = "";
    }
    ToastServices.SucessToast("Filter reset successfully");
  };

  useEffect(() => {
    const fetchDataWithDelay = async () => {
      await new Promise((resolve) => setTimeout(resolve, 3000));
      await loadStatus();
      await new Promise((resolve) => setTimeout(resolve, 5000));
      await loadCountry();
    };
    if (isAuthenticated) {
      fetchDataWithDelay();
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      loadData();
    }
    if (statusCode === true) {
      navigate("/");
      logoutAction();
    }
  }, [enqData]);

  const handleCreate = () => {
    navigate("/manage-job/create");
  };
  const handleUpdate = (id) => {
    navigate(`/manage-job/update/${id}`);
  };
  const handleView = (id) => {
    navigate(`/manage-job/view/${id}`);
  };

  return (
    <Fragment>
      <Div className="div_container d-flex justify-content space-between">
        <div className="d-flex justify-content-start flex-start">
          <div className="mt-10">
            <Typography
              className="heading"
              variant={"h2"}
              mb={5}
              fontWeight={600}
            >Jobs ({data?.length})</Typography>
          </div>

          <div className="">
            <Search className="search">
              <SearchIconWrapper>
                <SearchIcon className="search-icon" />
              </SearchIconWrapper>

              <StyledInputBase
                placeholder="Search"
                inputProps={{ "aria-label": "search" }}
                onChange={handleSearchChange}
                endAdornment={
                  searchInput && (
                    <InputAdornment position="end">
                      <IconButton onClick={handleClearSearch}>
                        <ClearIcon fontSize="12" />
                      </IconButton>
                    </InputAdornment>
                  )
                }
              />
            </Search>
          </div>
        </div>

        <div className="d-flex justify-content-end flex-end">
          <div className="ml-20 ">
            <Button
              variant="outlined"
              className="outlined_btn"
              onClick={handleCreate}
            >
              <AddIcon className="mr-5" />
              Create
            </Button>
          </div>
          <div className="ml-20 ">
            <Button
              variant="outlined"
              className="outlined_btn"
              onClick={handleFilter}
            >
              <FilterListIcon className="mr-5" />
              Filter
            </Button>
          </div>
          <div className="ml-20  ">
            <Button
              variant="outlined"
              className="outlined_btn"
              onClick={handleReset}
            >
              <CachedIcon className="mr-5" />
              Reset
            </Button>
          </div>
        </div>
      </Div>
      <Card className="responsive_card">
        <CardContent>
          <Div>
            <Table className="common_table">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <TableSortLabel
                      active={sortKey === "createdAt"}
                      direction={sortType}
                      onClick={() => handleSort("createdAt")}
                    >
                      Date
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                      active={sortKey === "title"}
                      direction={sortType}
                      onClick={() => handleSort("title")}
                    >
                      Job Title
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                      active={sortKey === `category`}
                      direction={sortType}
                      onClick={() => handleSort(`category`)}
                    >
                      Job Category
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                      active={sortKey === "positions"}
                      direction={sortType}
                      onClick={() => handleSort("positions")}
                    >
                      No. of Positions
                    </TableSortLabel>
                  </TableCell>

                  <TableCell>
                    <TableSortLabel
                      active={sortKey === "expiryDate"}
                      direction={sortType}
                      onClick={() => handleSort("expiryDate")}
                    >
                      Job Expiry Date
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading && (
                  <>
                    <LoaderComp />
                   
                  </>
                ) 
              }
                {
                  data?.map((item, i) => {
                    return (
                      <TableRow>
                        <TableCell>
                          {moment(item?.createdAt).format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell>
                         <span className="link" onClick={() => handleView(item?.id)}>
                          {item?.jobTitle?.length > 30? (
                            <>
                             <Tooltip title={item?.jobTitle}>
                              {item?.jobTitle?.substring(0, 30)}...
                              </Tooltip>
                            </>
                          ) : item?.jobTitle}
                        </span>
                        </TableCell>
                        <TableCell>
                         {item?.category?.categoryName?.length > 30? (
                            <>
                             <Tooltip  title={item?.category?.categoryName}>
                             {item?.category?.categoryName?.substring(0, 30)}...
                              </Tooltip>
                            </>
                          ) : item?.category?.categoryName}
                        </TableCell>
                        <TableCell>{item?.noOfPositions}</TableCell>
                        <TableCell>
                          {moment(item?.jobExpiryDate).format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell>
                          {item?.status === 1 ? (
                            <p className="p-active status">Active</p>
                          ) : (
                            <p className="p-inactive status">Inactive</p>
                          )}
                        </TableCell>
                        <TableCell>
                          <IconButton
                          className="p-0"
                            aria-label="more"
                            id="long-button"
                            aria-controls={open ? "long-menu" : undefined}
                            aria-expanded={open ? "true" : undefined}
                            aria-haspopup="true"
                            onClick={(event) => handleClick(event, i)}
                          >
                            <MoreVertIcon />
                          </IconButton>
                        </TableCell>
                        <Menu
                          className="custom_popover"
                          id="fade-menu"
                          MenuListProps={{
                            "aria-labelledby": "fade-button",
                          }}
                          open={selectedIndex === i}
                          anchorEl={anchorEl}
                          onClose={handleClose}
                          TransitionComponent={Fade}
                        >
                           <MenuItem onClick={() => handleView(item?.id)}>
                            View
                          </MenuItem>
                          <MenuItem onClick={() => handleUpdate(item?.id)}>
                            Update
                          </MenuItem>
                          <MenuItem onClick={() => handleStatus(item?.id, item?.status)}>
                            {item?.status === 1
                              ? "Mark as Inactive"
                              : "Mark as Active"}
                          </MenuItem>
                          <MenuItem onClick={()=> handleDelete(item?.id)}
                          >
                            Delete
                          </MenuItem>
                        </Menu>
                      </TableRow>
                    );
                  })
                }
                 {data?.length === 0 ||  error ? ( <NoRecordsFound tablecell={7} />) : ""}
              </TableBody>
            </Table>

            <div
              style={{
                display: "flex",
                alignItems: "end",
                justifyContent: "flex-end",
                marginTop: "20px",
              }}
            >
              <div className="count_page">
                <span className="mr-10">Items per page :</span>
                <select
                  className="pagination_selectbox"
                  value={itemsPerPage}
                  onChange={handleItemsPerPageChange}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                </select>
              </div>
              <Stack spacing={2}>
                <Pagination
                  count={totalPage}
                  page={page}
                  onChange={handlePaginationChange}
                />
              </Stack>
            </div>
          </Div>
        </CardContent>
      </Card>

      <div>
        <Drawer
          variant="temporary"
          anchor={"right"}
          open={filterOpen}
          onClose={handleFilterToggle}
        >
          <Box sx={{ width: "400px" }}>
            <div className="sidebar_header">
              <h1> Filter </h1>
              <ClearIcon
                sx={{ cursor: "pointer" }}
                onClick={handleFilterClose}
              />
            </div>

            <div className="sideform_container">
              <form onSubmit={formik.handleSubmit}>
                <Div>
                  <Typography className="from_label">From Date</Typography>

                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      name="fromDate"
                      className= { formik.touched.fromDate && formik.errors.fromDate ? "form_new_style date_error"  : 'form_new_style'  } 
                      value={formik.values.fromDate}
                      open={dateopen}
                      slotProps={{
                        textField: { onClick: () => setDateOpen(true) },
                      }}
                      onClose={() => setDateOpen(false)}
                      onChange={(newDate, event) => {
                        setFromDate(newDate);
                        formik.setFieldValue("fromDate", newDate);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                      disableFuture
                      format="dd/MM/yyy"
                    />
                    {formik.touched.fromDate && formik.errors.fromDate ? (
                      <Typography color="error">
                        <FormHelperText>
                        {"From date is required"}
                        </FormHelperText>
                      </Typography>
                    ) : null}
                  </LocalizationProvider>
                </Div>

                <Div sx={{ mt: 3 }}>
                  <Typography className="from_label">To Date</Typography>

                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                       className= { formik.touched.toDate && formik.errors.toDate ? "form_new_style date_error"  : 'form_new_style'  } 
                      name="toDate"
                      value={formik.values.toDate}
                      open={todateOpen}
                      slotProps={{
                        textField: { onClick: () => setTodateOpen(true) },
                      }}
                      onClose={() => setTodateOpen(false)}
                      onChange={(newDate, event) => {
                        setToDate(newDate);
                        formik.setFieldValue("toDate", newDate);
                      }}
                      disableFuture
                      format="dd/MM/yyy"
                      minDate={formik.values.fromDate}
                      renderInput={(params) => <TextField {...params} />}
                    />
                    {formik.touched.toDate && formik.errors.toDate ? (
                      <Typography color="error">
                          <FormHelperText>
                          {formik.errors.toDate}
                          </FormHelperText>
                       
                      </Typography>
                    ) : null}
                  </LocalizationProvider>
                </Div>

                <Div sx={{ mt: 3 }}>
                  <Typography className="from_label">Status</Typography>

                  <FormControl fullWidth>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      name="status"
                      value={formik.values.status}
                      onChange={formik.handleChange}
                      style={{ width: "100%" }}
                      displayEmpty
                      MenuProps={{
                        classes: { paper: "custom-menu-paper-select" }, // Assign a class to the dropdown menu
                      }}
                      renderValue={
                        formik.values.status !== ""
                          ? undefined
                          : () => "Select Status"
                      }
                    >  
                    <MenuItem value={"1"}>Active</MenuItem>
                    <MenuItem value={"0"}>Inactive</MenuItem>
                     
                      
                    </Select>
                    {formik.touched.status && formik.errors.status ? (
                      <Typography color="error">
                        {formik.errors.status}
                      </Typography>
                    ) : null}
                  </FormControl>
                </Div>

                <Div sx={{ mt: 3 }}>
                  <Typography className="from_label">Job Category</Typography>

                  <FormControl fullWidth>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      name="category"
                      value={formik.values.category}
                      onChange={formik.handleChange}
                      style={{ width: "100%" }}
                      displayEmpty
                      MenuProps={{
                        classes: { paper: "custom-menu-paper-select" }, // Assign a class to the dropdown menu
                      }}
                      renderValue={
                        formik.values.category !== ""
                          ? undefined
                          : () => "Select Job Category"
                      }
                    >
                      {category?.map((item) => {
                        return (
                          <MenuItem value={item?.id}>
                            {item?.categoryName}
                          </MenuItem>
                        );
                      })}
                    </Select>
                   
                  </FormControl>
                </Div>

                <Div
                  sx={{
                    mt: 10,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <LoadingButton
                    loading={loading}
                    className="filter_bttn"
                    type="submit"
                    variant="contained"
                    fullWidth
                    style={{ marginRight: "10px" }}
                  >
                    Filter
                  </LoadingButton>

                  <Button
                    className="clear_btn"
                    onClick={handleClear}
                    variant="contained"
                    fullWidth
                    style={{ marginLeft: "10px" }}
                  >
                    Clear
                  </Button>
                </Div>

                <Div></Div>
              </form>
            </div>
          </Box>
        </Drawer>
      </div>
    </Fragment>
  );
};

export default ManageJobs;
